import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import { iniciais, corAvatar } from "../lib/format";

/** Lista dos alunos vinculados — só aparece quando o responsável tem mais de
    um. Cada card abre o dashboard DAQUELE aluno; nenhuma comparação entre
    eles aparece aqui nem em lugar nenhum do módulo. */
export function SeletorAluno({ alunos, basePath }) {
  return (
    <div>
      <p className="text-muted mb-3">
        Selecione um aluno para ver o desempenho:
      </p>
      <div className="d-flex flex-wrap" style={{ gap: 20 }}>
        {alunos.map(aluno => {
          const nomeCompleto = [aluno.name, aluno.surname]
            .filter(Boolean)
            .join(" ");
          return (
            <Link
              key={aluno.id}
              to={`${basePath}/aluno/${aluno.id}`}
              className="seletor-aluno-card d-flex flex-column align-items-center text-decoration-none border rounded"
              style={{
                gap: 12,
                flex: "1 1 180px",
                minWidth: 180,
                padding: "28px 16px",
                color: "inherit",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                transition: "box-shadow 0.15s ease, transform 0.15s ease"
              }}
            >
              <div
                className="d-flex align-items-center justify-content-center rounded-circle text-white font-weight-bold"
                style={{
                  width: 72,
                  height: 72,
                  background: corAvatar(aluno.id),
                  fontSize: 24,
                  flexShrink: 0
                }}
              >
                {iniciais(nomeCompleto)}
              </div>
              <span
                className="text-center"
                style={{ fontSize: 15, fontWeight: 600 }}
              >
                {nomeCompleto}
              </span>
            </Link>
          );
        })}
      </div>
      <style>{`
        .seletor-aluno-card:hover {
          box-shadow: 0 4px 12px rgba(0,0,0,0.12);
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
}

SeletorAluno.propTypes = {
  alunos: PropTypes.arrayOf(
    PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string })
  ).isRequired,
  basePath: PropTypes.string.isRequired
};
